/*
  NOTE: This helper exports a custom validation rule for the Vee Validate plugin:
  https://vee-validate.logaretm.com/v4/guide/global-validators
*/

import creditCardType from 'credit-card-type';



const validateCvv = (value, params) => {
  const { cardNumber, cardType } = Array.isArray(params) ? {} : (params || {});
  let requiredCodeLength = 3;

  if (cardType) {
    const type = cardType.toLowerCase().replace(/[\s_]/g, '-');
    const isAmex = ['american-express', 'amex'].includes(type);
    if (isAmex) requiredCodeLength = 4;
  }
  else if (cardNumber) {
    const detectedCard = creditCardType(cardNumber)[0];
    if (detectedCard) requiredCodeLength = detectedCard.code.size;
  }

  if (new RegExp(`^[0-9]{${requiredCodeLength}}$`).test(value)) {
    return true;
  }

  return 'Invalid CVV';
};



export default validateCvv;
